import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../hybrid/wrappers';
import T from '../../../../common/components/T';
import defaultCss from './SingleButton.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';
import { generateUniqueId } from '../../../../common/utils/utils';
import CircleLoader from '../../../plug/CircleLoader';

const SingleButton = (props) => {
    const {
        formName,
        clickFunc,
        buttonText,
        type,
        customButton,
        icon,
        arrow,
        customStyles,
        disabled,
        hiddenButtonText,
        requestLoading
    } = props;

    const componentCss = { ...customStyles, ...defaultCss };
    const { stylers, classes } = generateCompStylers(componentCss);
    const { stylersBtn, classesBtn } = generateCompStylers(customButton, 'Btn');
    return (
        <div
            style={{
                ...stylers.formGroupButtonItem,
                ...stylersBtn.singleButton
            }}
            className={classnames(classes.formGroupButtonItem, classesBtn.singleButton)}
        >
            <div
                style={{
                    ...(type === 'ok' ? stylers.formButtonPrimary : stylers.buttonGray),
                    ...stylersBtn.butWrapper
                }}
                className={classnames(
                    type === 'ok' ? classes.formButtonPrimary : classes.buttonGray,
                    { [classes.buttonGrayBordered]: type !== 'ok' && customButton?.bordered },
                    classesBtn.butWrapper,
                    ...(disabled ? [classes?.formButtonPrimaryDisabled, classesBtn?.formButtonPrimaryDisabled] : [])
                )}
                onClick={disabled ? () => false : clickFunc}
                {...{ 'data-testid': `${formName}_${type}` }}
            >
                {requestLoading && type === 'ok' ? (
                    <CircleLoader color={'var(--whiteColor)'} className={defaultCss.buttonLoader} />
                ) : null}
                {requestLoading && type === 'ok'
                    ? null
                    : icon && (
                          <div
                              style={{ display: 'flex', marginRight: '10px', ...stylersBtn?.spriteWrapper }}
                              className={classesBtn.spriteWrapper}
                          >
                              {svgSprite(icon, {
                                  style: {
                                      width: '18px',
                                      height: '18px',
                                      ...(stylersBtn?.sprite || {})
                                  },
                                  className: classesBtn?.sprite || ''
                              })}
                          </div>
                      )}
                {requestLoading && type === 'ok'
                    ? null
                    : !hiddenButtonText && (
                          <p
                              style={stylersBtn?.butText}
                              className={classnames(classes.butText, classesBtn?.butText)}
                              key={generateUniqueId()}
                          >
                              {buttonText || <T textName='cancel' defaultStr='Отмена' page='all' />}
                          </p>
                      )}
                {requestLoading && type === 'ok'
                    ? null
                    : arrow && (
                          <div
                              className={classesBtn?.arrowWrapper}
                              style={{
                                  marginLeft: '20px',
                                  borderLeft: '1px solid var(--whiteLessTransparentColor)',
                                  padding: '0 17px',
                                  height: '60px',
                                  ...stylersBtn.arrowWrapper
                              }}
                          >
                              {svgSprite('angle-down', {
                                  className: classesBtn.buttonArrow,
                                  style: stylersBtn.buttonArrow
                              })}
                          </div>
                      )}
            </div>
        </div>
    );
};
SingleButton.propTypes = {
    styles: PropTypes.object,
    clickFunc: PropTypes.func,
    buttonText: PropTypes.node,
    type: PropTypes.string,
    customButton: PropTypes.object,
    icon: PropTypes.string,
    arrow: PropTypes.bool,
    customStyles: PropTypes.object
};
export default SingleButton;
